/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control.ng-touched.ng-invalid[_ngcontent-%COMP%]{border-bottom:2px solid red}.justify-content-end[_ngcontent-%COMP%]{justify-content:end}"];
export { styles as styles };
